// src/ui/adminStyles.js

const adminStyles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid #ddd",
  },
  th: {
    borderBottom: "2px solid #ddd",
    padding: "6px 10px",
    textAlign: "left",
    background: "#f3f4f6",
    fontSize: 13,
    whiteSpace: "nowrap",
  },
  td: {
    borderBottom: "1px solid #eee",
    padding: "6px 10px",
    fontSize: 13,
    lineHeight: "1.2",
    verticalAlign: "middle",
  },
  badge: {
    padding: "1px 6px",
    borderRadius: 10,
    color: "white",
    fontSize: 11,
    whiteSpace: "nowrap",
  },
  linkButton: {
    background: "none",
    border: "none",
    padding: 0,
    color: "#2563eb",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: "inherit",
  },
  modalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    background: "white",
    padding: 20,
    borderRadius: 6,
    width: 400,
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
  },
};

export default adminStyles;
